// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__q2ruW","settingSync":"style_settingSync__AHHB5","snoozeBtn":"style_snoozeBtn__jmjGX"};